import { isTruthy } from 'notable-common';
import { z } from 'zod';
export var FlowPatientDataStoreFilterOperator;
(function (FlowPatientDataStoreFilterOperator) {
    FlowPatientDataStoreFilterOperator["Equals"] = "Equals";
    FlowPatientDataStoreFilterOperator["NotEquals"] = "NotEquals";
    FlowPatientDataStoreFilterOperator["GreaterThan"] = "GreaterThan";
    FlowPatientDataStoreFilterOperator["GreaterThanOrEqualTo"] = "GreaterThanOrEqualTo";
    FlowPatientDataStoreFilterOperator["LessThan"] = "LessThan";
    FlowPatientDataStoreFilterOperator["LessThanOrEqualTo"] = "LessThanOrEqualTo";
    FlowPatientDataStoreFilterOperator["Contains"] = "Contains";
    FlowPatientDataStoreFilterOperator["DoesNotContain"] = "DoesNotContain";
    FlowPatientDataStoreFilterOperator["StartsWith"] = "StartsWith";
    FlowPatientDataStoreFilterOperator["EndsWith"] = "EndsWith";
    FlowPatientDataStoreFilterOperator["IsOneOf"] = "IsOneOf";
    FlowPatientDataStoreFilterOperator["IsNotOneOf"] = "IsNotOneOf";
    FlowPatientDataStoreFilterOperator["IsEmpty"] = "IsEmpty";
    FlowPatientDataStoreFilterOperator["IsNotEmpty"] = "IsNotEmpty";
})(FlowPatientDataStoreFilterOperator || (FlowPatientDataStoreFilterOperator = {}));
export var FlowPatientDataStoreFilterMatchRule;
(function (FlowPatientDataStoreFilterMatchRule) {
    FlowPatientDataStoreFilterMatchRule["All"] = "All";
    FlowPatientDataStoreFilterMatchRule["Any"] = "Any";
})(FlowPatientDataStoreFilterMatchRule || (FlowPatientDataStoreFilterMatchRule = {}));
export var FlowPatientDataStoreCaseSensitivity;
(function (FlowPatientDataStoreCaseSensitivity) {
    FlowPatientDataStoreCaseSensitivity["ExactMatch"] = "ExactMatch";
    FlowPatientDataStoreCaseSensitivity["IgnoreCase"] = "IgnoreCase";
})(FlowPatientDataStoreCaseSensitivity || (FlowPatientDataStoreCaseSensitivity = {}));
export var FlowPatientDataStoreSortDirection;
(function (FlowPatientDataStoreSortDirection) {
    FlowPatientDataStoreSortDirection["Ascending"] = "Ascending";
    FlowPatientDataStoreSortDirection["Descending"] = "Descending";
})(FlowPatientDataStoreSortDirection || (FlowPatientDataStoreSortDirection = {}));
const fieldPathRegex = /^[a-zA-Z_]\w*(\.[a-zA-Z_]\w*)*$/;
const fieldPathErrorMessage = 'Field path must use dot notation only (e.g., "startTime" or "rawJson.type.coding")';
const FilterOperationSchema = z.object({
    id: z.uuid(),
    fieldToFilter: z.string().regex(fieldPathRegex, fieldPathErrorMessage),
    operator: z.enum(FlowPatientDataStoreFilterOperator),
    caseSensitive: z.enum(FlowPatientDataStoreCaseSensitivity),
    value: z.unknown().optional(),
});
export const FlowPatientDataStoreSortConfigSchema = z
    .object({
    fieldToSort: z.string(),
    sortDirection: z
        .enum(FlowPatientDataStoreSortDirection)
        .default(FlowPatientDataStoreSortDirection.Descending),
})
    .transform((config) => (isTruthy(config.fieldToSort) ? config : undefined));
export const FlowPatientDataStoreFilterConfigSchema = z.object({
    matchRule: z.enum(FlowPatientDataStoreFilterMatchRule),
    filterOperations: z.array(FilterOperationSchema),
});
//# sourceMappingURL=filterAndSortConfig.js.map